import graphqlClient from "../../api/axios_interceptor";
import {
    addMobileAccountsMutation,
    addBankAccountsMutation,
    queryWalletBalance,
    queryWithdrawalBankAccounts,
    queryWithdrawalMobileAccounts,
    updateBankAccountsMutation,
    updateMobileAccountsMutation,
    deleteMobileAccountsMutation,
    deleteBankAccountsMutation,
    SendOtpTypeMutation,
    VerifyOtpMutation,
    WithdrawalRequestMutation,
    cancelWithdrawalRequestMutation,
    queryWithdrawalRequests,
    queryStatusChoices
} from "../../api/graphql/queries/withdrawals";
import { FETCH_WALLET_BALANCE, FETCH_WITHDRAWALS_BANK_ACCOUNTS, FETCH_WITHDRAWALS_MOBILE_ACCOUNTS, ADD_WITHDRAWALS_BANK_ACCOUNTS, ADD_WITHDRAWALS_MOBILE_ACCOUNTS, DELETE_WITHDRAWALS_MOBILE_ACCOUNTS, UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS, DELETE_WITHDRAWALS_BANK_ACCOUNTS, UPDATE_WITHDRAWALS_BANK_ACCOUNTS, SEND_OTP, VERIFY_OTP, WITHDRAWAL_REQUEST, FETCH_WITHDRAWALS_DATA, CANCEL_WITHDRAWAL_REQUEST } from "../actions/actionTypes"; // Import your action type
import { updateActionErrors } from "./updateErrors";

const fetchWithdrawalsBankAccountsMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
          query: queryWithdrawalBankAccounts(),
        },
      }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
          }
          else {
            let result = queryResult.data.data.withdrawalBankAccounts;
            action.payload = result;
          }
        });
      } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
      }
      return action;
}

const fetchWithdrawalsMobileAccountsMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
          query: queryWithdrawalMobileAccounts(),
        },
      }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
          }
        else {
          let result = queryResult.data.data.withdrawalMobileAccounts;
          action.payload = result;
        }
        });
  } catch (error) {
    console.error(error);
  }
  return action;
}

const fetchWalletBalance = async (action) => {
  try {
    await graphqlClient({
        data: {
          query: queryWalletBalance(),
        },
      }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
          }
        else {
          let result = queryResult.data.data.walletBalance;
          action.payload = result;
        }
        });
  } catch (error) {
    console.error(error);
  }
  return action;
}

const addWithdrawalBankAccountMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
          query: addBankAccountsMutation([action.payload]),
        },
      }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
          } else if (queryResult.data.data.addWithdrawalBankAccount.success === false) {
            let error = queryResult.data.data.addWithdrawalBankAccount.errorMessage;
            action = updateActionErrors(action, error);
          } else if (queryResult.data.data.addWithdrawalBankAccount.success === true) {
            action.payload = queryResult.data.data.addWithdrawalBankAccount.bankAccounts;
          }
        });
  } catch (error) {
    console.error(error);
  }
  return action;
}

const addWithdrawalMobileAccountMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
          query: addMobileAccountsMutation([action.payload]),
        },
      }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
          } else if (queryResult.data.data.addWithdrawalMobileAccount.success === false) {
            let error = queryResult.data.data.addWithdrawalMobileAccount.errorMessage;
            action = updateActionErrors(action, error);
          } else if (queryResult.data.data.addWithdrawalMobileAccount.success === true) {
            action.payload = queryResult.data.data.addWithdrawalMobileAccount.mobileAccounts;
          }
        });
  } catch (error) {
    console.error(error);
  }
  return action;
}

const updateWithdrawalBankAccountMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
            query: updateBankAccountsMutation([action.payload]),
        },
    }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
        } else if (queryResult.data.data.updateWithdrawalBankAccount.success === false) {
            let error = queryResult.data.data.updateWithdrawalBankAccount.errorMessage;
            action = updateActionErrors(action, error);
        } else if (queryResult.data.data.updateWithdrawalBankAccount.success === true) {
            action.payload = queryResult.data.data.updateWithdrawalBankAccount.bankAccounts;
        }
    });
  } catch (error) {
      console.error(error);
  }
  return action;
}

const updateWithdrawalMobileAccountMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
            query: updateMobileAccountsMutation([action.payload]),
        },
    }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
        } else if (queryResult.data.data.updateWithdrawalMobileAccount.success === false) {
            let error = queryResult.data.data.updateWithdrawalMobileAccount.errorMessage;
            action = updateActionErrors(action, error);
        } else if (queryResult.data.data.updateWithdrawalMobileAccount.success === true) {
            action.payload = queryResult.data.data.updateWithdrawalMobileAccount.mobileAccounts;
        }
    });
  } catch (error) {
      console.error(error);
  }
  return action;
}

const deleteWithdrawalBankAccountMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
            query: deleteBankAccountsMutation(action.payload),
        },
    }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
        } else if (queryResult.data.data.deleteWithdrawalBankAccount.success === false) {
            let error = queryResult.data.data.deleteWithdrawalBankAccount.errorMessage;
            action = updateActionErrors(action, error);
        }
    });
  } catch (error) {
      console.error(error);
  }
  return action;
}

const deleteWithdrawalMobileAccountMiddleware = async (action) => {
  try {
    await graphqlClient({
        data: {
            query: deleteMobileAccountsMutation(action.payload),
        },
    }).then((queryResult) => {
        if (queryResult.data.errors) {
            action = updateActionErrors(action, queryResult.data.errors);
        } else if (queryResult.data.data.deleteWithdrawalMobileAccount.success === false) {
            let error = queryResult.data.data.deleteWithdrawalMobileAccount.errorMessage;
            action = updateActionErrors(action, error);
        }
    });
  } catch (error) {
      console.error(error);
  }
  return action;
}


const cancelWithdrawalRequestMiddleware = async (action) => {
  try {
      await graphqlClient({
          data: {
              query: cancelWithdrawalRequestMutation(action.payload.id),
          },
      }).then((queryResult) => {
          if (queryResult.data.errors) {
              action = updateActionErrors(action, queryResult.data.errors);
          } else {
              const cancelResult = queryResult.data.data.cancelWithdrawalRequest;
              if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
              } else if (cancelResult.success === false) {
                  const error = cancelResult.errorMessage;
                  action = updateActionErrors(action, error);
              } else{
                action.payload = cancelResult.customerWithdrawal;
              }
          }
      });
  } catch (error) {
      console.error(error);
  }
  return action;
};

const fetchWithdrawalRequestsMiddleware = async (action) => {
  try {
      await graphqlClient({
          data: {
              query: queryWithdrawalRequests(),
          },
      }).then((queryResult) => {
          if (queryResult.data.errors) {
              action = updateActionErrors(action, queryResult.data.errors);
          } else {
              const withdrawalRequestsTableData = queryResult.data.data.withdrawalRequests.withdrawals;
              const withdrawalRequestsSummary = queryResult.data.data.withdrawalRequests.summary;
              action.payload = { withdrawalRequestsSummary, withdrawalRequestsTableData };
          }
      });
  } catch (error) {
      console.error(error);
  }
  return action;
};

const fetchStatusChoicesMiddleware = async (action) => {
  try {
      await graphqlClient({
          data: {
              query: queryStatusChoices(),
          },
      }).then((queryResult) => {
          if (queryResult.data.errors) {
              action = updateActionErrors(action, queryResult.data.errors);
          } else {
              const statusChoices = queryResult.data.data.statusChoices;
              action.payload = statusChoices;
          }
      });
  } catch (error) {
      console.error(error);
  }
  return action;
};


const withdrawalsMiddleware = (storeAPI) => (next) => async (
  action
) => {
  switch (action.type) {
    case FETCH_WITHDRAWALS_BANK_ACCOUNTS:
      action = await fetchWithdrawalsBankAccountsMiddleware(action);
      break;
    case FETCH_WITHDRAWALS_MOBILE_ACCOUNTS:
      action = await fetchWithdrawalsMobileAccountsMiddleware(action);
      break;
    case FETCH_WALLET_BALANCE:
      action = await fetchWalletBalance(action);
      break;
    case ADD_WITHDRAWALS_BANK_ACCOUNTS:
      action = await addWithdrawalBankAccountMiddleware(action);
      break;
    case ADD_WITHDRAWALS_MOBILE_ACCOUNTS:
      action = await addWithdrawalMobileAccountMiddleware(action);
      break;
    case UPDATE_WITHDRAWALS_BANK_ACCOUNTS:
      action = await updateWithdrawalBankAccountMiddleware(action);
    break;
    case UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS:
      action = await updateWithdrawalMobileAccountMiddleware(action);
    break;
    case DELETE_WITHDRAWALS_BANK_ACCOUNTS:
      action = await deleteWithdrawalBankAccountMiddleware(action);
    break;
    case DELETE_WITHDRAWALS_MOBILE_ACCOUNTS:
      action = await deleteWithdrawalMobileAccountMiddleware(action);
    break;
    case FETCH_WITHDRAWALS_DATA:
      action = await fetchWithdrawalRequestsMiddleware(action);
    break;
    case CANCEL_WITHDRAWAL_REQUEST:
      action = await cancelWithdrawalRequestMiddleware(action);
    break;
    case SEND_OTP:
      try {
        await graphqlClient({
          data: {
            query: SendOtpTypeMutation(action.payload.confirmationChannel),
          },
        }).then((queryResult) => {
          if (queryResult.data.errors && queryResult.data.errors.length > 0) {
            action = updateActionErrors(action, queryResult.data.errors);
          } else if (queryResult.data.data.sendOtp.success === false) {
            let error = queryResult.data.data.sendOtp.errorMessage;
            action = updateActionErrors(action, error);
          } else if (queryResult.data.data.sendOtp.success === true) {
            action.successMessage = queryResult.data.data.sendOtp.successMessage;
            action.authSessionExpiry = queryResult.data.data.sendOtp.authSessionExpiry;
            action.otpCodeExpiry = queryResult.data.data.sendOtp.otpCodeExpiry;
          }
        });
      } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
      }
      break;

    case VERIFY_OTP:
      try {
        await graphqlClient({
          data: {
            query: VerifyOtpMutation(action.payload.otpCode),
          },
        }).then((queryResult) => {
          if (queryResult.data.errors && queryResult.data.errors.length > 0) {
             action = updateActionErrors(action, queryResult.data.errors);
          } else if (queryResult.data.data.verifyOtp.success === false) {
            let error = queryResult.data.data.verifyOtp.errorMessage;
            action.errors = error;
          } else if (queryResult.data.data.verifyOtp.success === true) {
            action.success = true;
          }
        });
      } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
      }
      break;
      case WITHDRAWAL_REQUEST:
        try {
          await graphqlClient({
            data: {
              query: WithdrawalRequestMutation(
                action.payload.withdrawTo,
                action.payload.amount,
                action.payload.mobileAccId,
                action.payload.bankAccId
              ),
            },
          }).then((queryResult) => {
            if (queryResult.data.errors && queryResult.data.errors.length > 0) {
              action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.addWithdrawalRequest.success === false) {
              let error = queryResult.data.data.addWithdrawalRequest.errorMessage;
              action = updateActionErrors(action, error);
            } else if (queryResult.data.data.addWithdrawalRequest.success === true) {
              action.success = true;
              action.successMessage = queryResult.data.data.addWithdrawalRequest.successMessage;
            }
          });
        } catch (error) {
          console.error(error);
          action = updateActionErrors(action, error);
        }
        break;
  }
  return next(action);
};

export{ withdrawalsMiddleware }